import React, { Component } from 'react';
import BioPhoto from './BioPhoto';
import MemberQRCard from './MemberQRCard';
import zarawink from '../assets/zarawink.png';
import bmz from '../assets/bmz.png';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Bio.css';

class BioZarawink extends Component {
  state = {
    user: null,
    loading: true,
    error: '',
  };

  async componentDidMount() {
    try {
      const email = localStorage.getItem('email');

      if (!email) {
        throw new Error('No email found. Please login again.');
      }

      const res = await fetch(`/user-details?email=${encodeURIComponent(email)}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to fetch user data');
      }

      this.setState({
        user: {
          email: data.email,
          balance: data.balance,
          name: 'MR.ZARAWIN KANCHANAPORN',
          dojo: 'BANGKOK MARTIAL ARTS AND ZEN CENTER, BANGKOK, THAILAND',
          rank: '5 KYU',
          rankDate: 'N/A',
          membershipNumber: '6758',
          membershipExpiry: 'N/A',
          nationality: 'THAILAND',
        },
        loading: false,
      });

    } catch (err) {
      console.error('Error fetching user data:', err);
      this.setState({
        error: err.message,
        loading: false,
      });
    }
  }

  renderUserInfo() {
    const { user } = this.state;

    return (
      <div style={{ marginBottom: '20px' }}>
        <div><strong>Email:</strong> {user.email}</div>
        <div><strong>Balance:</strong> {user.balance}</div>
      </div>
    );
  }

  renderRank() {
    const { user } = this.state;

    if (!user) return '5 KYU (N/A)';

    return user.rankDate
      ? `${user.rank} (${user.rankDate})`
      : user.rank;
  }

  render() {
    const { user, loading, error } = this.state;

    return (
      <div className="BioNiratb">
      <img
      className="top-logo"
      src={logo}
      alt="App Logo"
      />
        <h1>Member's Biography</h1>

        {loading && <div>Loading user data...</div>}

        {error && (
          <div style={{ color: 'red', marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {user && this.renderUserInfo()}


        <BioPhoto
          slug="zarawink"
          fallback={zarawink}
          className="zarawink"
          alt="Zarawin Kanchanaporn"
        />

        <h2>{user ? user.name : 'MR.ZARAWIN KANCHANAPORN'}</h2>

        <img
          className="bmz"
          src={bmz}
          alt="Bangkok Martial Arts and Zen Center"
        />

        <br />
        <br />

        <div>
          DOJO : {user ? user.dojo : 'BANGKOK MARTIAL ARTS AND ZEN CENTER, BANGKOK, THAILAND'}
        </div>

        <div>
          CURRENT RANK : {this.renderRank()}
        </div>

        <div>
          AAT MEMBERSHIP NUMBER : {user ? `${user.membershipNumber} (Expired : ${user.membershipExpiry})` : '6758 (Expired : N/A)'}
        </div>

        <div>
          DATE OF BIRTH : N/A
        </div>

        <div>
          NATIONALITY : {user ? user.nationality : 'THAILAND'}
        </div>

        <br />

        <MemberQRCard slug="zarawink" />

        <br />

        <div>Powered by</div>

        <img
          className="logo2"
          src={logo2}
          alt="New Wave Consulting Group logo"
        />

        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default BioZarawink;
